// App Constants    
import { PATHS } from 'AppConstants';

// API Setup
import { getccbAxiosConfig } from '../apisSetup/ccbConfig';

// API Caller
const ccbAxiosApiCaller = getccbAxiosConfig(true, false, false);

// Budget API call
export const fetchBudgetListApi = (payload) => ccbAxiosApiCaller.post(PATHS.GET_BUDGET_LIST, { ...payload });
export const fetchBudgetExportApi = (payload) => ccbAxiosApiCaller.post(PATHS.GET_BUDGET_EXPORT, { ...payload });
